module.exports = __webpack_public_path__ + "img/xpu-ha-pool.d5f81652.jpg";